import React, { useEffect, useState } from "react";
import EconomyReport from "./Economy/EconomyReport";
import EnvironmentReport from "./Environment/EnvironmentReport";
import NutrientReport from "./Nutrition/NutritionReport";
import "./ReportStyle.css";

const LastPurchase = ({ inventory, trash }) => {
  const [loading, setLoading] = useState(true);
  const [itemsFromLastPurchase, setItemsFromLastPurchase] = useState("");

  const getItemsFromLastPurchase = () => {
    /* --- SEARCHES THROUGH INVENTORY AND TRASH, LOCALIZES THE LAST ADDED ITEM TO DETERMINE LAST PURCHASE--- */
    let lastAddedItem = "";

    inventory.forEach((item) => {
      if (lastAddedItem === "") {
        lastAddedItem = {
          date: new Date(item.dates[item.dates.length - 1]),
          item: item.EANcode,
        };
      } else {
        let compDate = new Date(item.dates[item.dates.length - 1]);
        if (compDate > lastAddedItem.date) {
          lastAddedItem = { date: compDate, item: item.EANcode };
        }
      }
    });

    trash.forEach((item) => {
      if (lastAddedItem === "") {
        lastAddedItem = {
          date: new Date(item.dates[item.dates.length - 1]),
          item: item.EANcode,
        };
      } else {
        let compDate = new Date(item.dates[item.dates.length - 1]);
        if (compDate > lastAddedItem.date) {
          lastAddedItem = { date: compDate, item: item.EANcode };
        }
      }
    });

    /* --- FINDS ALL ITEMS ADDED TO INVENTORY WITHIN 30 MINUTES OF THE LAST ADDED ITEM --- */
    let itemList = [];
    inventory.forEach((item) => {
      let dt1 = new Date(item.dates[item.dates.length - 1]);
      let dt2 = new Date(lastAddedItem.date);
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;

      diff /= 60;
      if (Math.abs(Math.round(diff)) < 30) {
        itemList.push(item);
      }
    });

    trash.forEach((item) => {
      let dt1 = new Date(item.dates[item.dates.length - 1]);
      let dt2 = new Date(lastAddedItem.date);
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;

      diff /= 60;
      if (Math.abs(Math.round(diff)) < 30) {
        itemList.push(item);
      }
    });

    return itemList;
  };

  useEffect(() => {
    setItemsFromLastPurchase(getItemsFromLastPurchase());
  }, []);

  useEffect(() => {
    if (itemsFromLastPurchase !== "") {
      setLoading(false);
    }
  }, [itemsFromLastPurchase]);

  return (
    <div className="reportBody">
      <h4 className="reportTitle">Last purchase</h4>
      {loading ? (
        <p>Loading....</p>
      ) : (
        <React.Fragment>
          {" "}
          <EconomyReport list={itemsFromLastPurchase} />{" "}
          <NutrientReport list={itemsFromLastPurchase} />
          <EnvironmentReport list={itemsFromLastPurchase} />
        </React.Fragment>
      )}
    </div>
  );
};

export default LastPurchase;
